<template>
  <div id="experience"
    class="flex flex-col sm:flex-row dark:bg-dark-code bg-gray-50 justify-around items-center">
    <ExperienceSkills />
    <ExperienceJobs />
  </div>
</template>

<script>
import ExperienceJobs from './ExperienceJobs.vue';
import ExperienceSkills from './ExperienceSkills.vue';

export default {
  components: {
    ExperienceJobs,
    ExperienceSkills,
  },
};
</script>
